<template>
  <v-container fluid class="events-admin">
    <p class="text-center title mt-6">Заходи</p>

    <v-row class="mt-5">
      <v-col cols="12" md="4" class="pt-0">
        <div class="d-flex justify-space-between align-center">
          <p class="text-sm-body-1 font-weight-bold mb-0">Усі заходи</p>
          <v-btn small class="mb-2" @click="resetForm">
            Створити
            <v-icon color="green">mdi-plus</v-icon>
          </v-btn>
        </div>
        <v-tabs v-model="statusTab" centered slider-color="white" background-color="primary">
          <v-tab v-for="tab in statusTabs" :key="tab.value" class="font-weight-bold font-gotham">{{ tab.label }}</v-tab>
        </v-tabs>
        <v-pagination
          v-if="meta.last_page > 1"
          v-model="page"
          :length="meta.last_page"
          prev-icon="mdi-menu-left"
          next-icon="mdi-menu-right"
          :total-visible="6"
          class="mt-3"
        ></v-pagination>
        <p v-if="!events.length && !listLoading" class="text-center mt-6 grey--text">Заходів немає</p>
        <v-card
          v-for="item in events"
          :key="item.id"
          class="mt-2"
          :class="{ 'events-admin__selected': item.id === eventId }"
          @click="selectEvent(item)"
        >
          <v-card-title class="text-sm-body-1 font-weight-bold">{{ item.title }}</v-card-title>
          <v-card-text class="d-flex align-center flex-wrap" style="gap: 12px">
            <v-icon small>{{ statusIcon(item.status) }}</v-icon>
            <span v-if="item.category">{{ item.category.name }}</span>
            <span v-if="item.published_at">{{ item.published_at }}</span>
            <span v-if="item.publish_at">публікація {{ item.publish_at }}</span>
            <span v-if="item.status === 'FINISHED'" class="grey--text">завершено, знято з сайту</span>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="8" class="pt-0">
        <p class="text-sm-body-1 font-weight-bold mb-3">
          {{ eventId ? "Редагування заходу" : "Новий захід" }}
        </p>
        <v-card class="px-4 pt-2 pb-4">
          <v-text-field v-model="form.title" label="Заголовок" counter="255"></v-text-field>
          <v-textarea
            v-model="form.short_description"
            label="Короткий опис (для картки в списку заходів)"
            rows="2"
            auto-grow
            counter="1000"
          ></v-textarea>
          <v-text-field v-model="form.seo_title" label="SEO заголовок"></v-text-field>
          <v-textarea v-model="form.seo_description" label="SEO опис" rows="3" auto-grow></v-textarea>
          <div class="d-flex align-center">
            <v-select
              v-model="form.event_category_id"
              :items="categories"
              item-text="name"
              item-value="id"
              label="Категорія (показується в «хлібних крихтах»: Заходи › Категорія)"
              clearable
            ></v-select>
            <v-btn icon class="ml-2" title="Категорії заходів" @click="categoriesDialog = true">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </div>
          <div class="d-flex flex-wrap" style="gap: 0 24px">
            <v-combobox
              v-model="form.format"
              :items="formatOptions"
              label="Онлайн або місто (тег на картці і фільтр)"
              hint="Напр. «онлайн» або «м. Дніпро»"
              persistent-hint
              clearable
              style="flex: 1 1 260px"
            ></v-combobox>
            <v-text-field
              v-model="form.starts_on"
              type="date"
              label="Дата початку (для сортування «найближчі»)"
              clearable
              style="flex: 1 1 220px"
            ></v-text-field>
            <v-text-field
              v-model="form.ends_on"
              type="date"
              label="Дата завершення (якщо захід кілька днів)"
              :min="form.starts_on || undefined"
              clearable
              style="flex: 1 1 220px"
            ></v-text-field>
          </div>
          <p class="text-caption grey--text text--darken-1 mb-0">
            Наступного дня після дати завершення (або дати початку, якщо захід один день) захід автоматично знімається з сайту
            і переходить у вкладку «Завершені». Без дат захід висить, доки його не знімуть вручну.
          </p>
        </v-card>

        <v-card class="px-4 pt-4 pb-4 mt-4">
          <p class="subtitle-1 font-weight-bold mb-1">Про захід</p>
          <p class="text-caption grey--text text--darken-1 mb-3">
            Блоки картки «Про захід» на сторінці. Назву кожного блоку можна змінити, блоки — додати, прибрати чи переставити.
            «Ціна» показує текст з іконкою, як «Скільки» в макеті.
          </p>
          <div v-for="(item, i) in form.details" :key="item.key" class="events-admin__detail">
            <div class="d-flex align-center flex-wrap" style="gap: 12px">
              <!-- placeholder instead of label: the hint disappears once the field is filled -->
              <v-text-field v-model="item.title" placeholder="Назва блоку" dense hide-details class="events-admin__detail-title"></v-text-field>
              <v-checkbox
                v-model="item.type"
                true-value="price"
                false-value="text"
                label="Ціна"
                dense
                hide-details
                class="mt-0 pt-0"
              ></v-checkbox>
              <v-spacer></v-spacer>
              <v-btn icon small :disabled="i === 0" title="Вище" @click="moveDetail(i, -1)"><v-icon>mdi-arrow-up</v-icon></v-btn>
              <v-btn icon small :disabled="i === form.details.length - 1" title="Нижче" @click="moveDetail(i, 1)"><v-icon>mdi-arrow-down</v-icon></v-btn>
              <v-btn icon small color="error" title="Прибрати блок" @click="form.details.splice(i, 1)"><v-icon>mdi-delete-outline</v-icon></v-btn>
            </div>
            <v-textarea
              v-model="item.text"
              :placeholder="item.type === 'price' ? 'Ціна, напр. 2 300 грн' : 'Текст'"
              rows="1"
              auto-grow
              dense
              class="mt-3"
              hide-details
            ></v-textarea>
          </div>
          <v-btn small text color="primary" class="mt-2" :disabled="form.details.length >= 12" @click="addDetail">
            <v-icon left small>mdi-plus</v-icon>
            Додати блок
          </v-btn>
        </v-card>

        <v-card class="px-4 pt-4 pb-2 mt-4">
          <p class="subtitle-1 font-weight-bold mb-1">Контакти</p>
          <p class="text-caption grey--text text--darken-1 mb-1">
            У картці «Контакти» — фото, ім'я, телефон, пошта й соцмережі з анкети психолога та перехід на анкету.
          </p>
          <v-autocomplete
            v-model="form.host_profile_id"
            :items="authors"
            item-text="label"
            item-value="id"
            label="Ведучий (психолог)"
            clearable
          ></v-autocomplete>
          <v-combobox
            v-model="form.host_title"
            :items="hostTitles"
            label="Підпис над ім'ям"
            hint="Напр. «Ведуча», «Ведучий», «Організатор» — можна вписати свій"
            persistent-hint
          ></v-combobox>
        </v-card>

        <div v-show="!previewUrl" class="events-admin__upload mt-4" @click="$refs.previewInput.click()">
          <div class="events-admin__upload-inner">
            <span>Картинка заходу</span>
          </div>
        </div>
        <div v-show="previewUrl" class="events-admin__preview mt-4" :style="{ backgroundImage: previewUrl ? `url(${previewUrl})` : '' }">
          <v-icon class="events-admin__preview-remove" @click="removePreview">mdi-close</v-icon>
        </div>
        <input ref="previewInput" hidden type="file" accept="image/png,image/gif,image/jpeg,image/webp" @change="onPreviewPicked">

        <p class="text-sm-body-1 font-weight-bold mt-6 mb-2">Текст заходу</p>
        <vue-editor
          id="event-editor"
          v-model="form.content"
          class="blog-editor"
          :editorToolbar="editorToolbar"
          useCustomImageHandler
          @image-added="handleImageAdded"
        />

        <div class="d-flex flex-wrap align-center justify-space-between mt-4" style="gap: 16px">
          <v-checkbox v-model="publishNow" color="primary" label="Опублікувати зараз" class="mt-0 pt-0" hide-details></v-checkbox>
          <v-menu v-model="dateMenu" :close-on-content-click="false" offset-y :disabled="publishNow">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="publishDate"
                label="Дата публікації"
                prepend-icon="mdi-calendar"
                readonly
                clearable
                hide-details
                :disabled="publishNow"
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="publishDate" first-day-of-week="1" locale="uk" @input="dateMenu = false"></v-date-picker>
          </v-menu>
          <v-text-field
            v-model="publishTime"
            type="time"
            label="Час"
            prepend-icon="mdi-clock-time-four-outline"
            hide-details
            :disabled="publishNow"
            style="max-width: 160px"
          ></v-text-field>
          <v-btn color="primary" depressed :loading="saving" @click="save">
            {{ eventId ? "Зберегти" : "Створити захід" }}
          </v-btn>
        </div>
        <p v-if="!publishNow && !publishDate" class="text-caption grey--text mt-2 mb-0">
          Без дати й без «Опублікувати зараз» захід збережеться як чернетка.
        </p>

        <div v-if="eventId" class="d-flex flex-wrap align-center justify-end mt-3">
          <v-btn v-if="eventStatus === 'PUBLISHED'" small text color="primary" :href="siteUrl + '/events/' + eventSlug" target="_blank" rel="noopener">
            <v-icon left small>mdi-open-in-new</v-icon>
            Переглянути на сайті
          </v-btn>
          <v-btn small text color="error" @click="deleteDialog = true">
            <v-icon left small>mdi-delete-outline</v-icon>
            Видалити захід
          </v-btn>
        </div>
      </v-col>
    </v-row>

    <v-dialog v-model="deleteDialog" max-width="420">
      <v-card>
        <v-card-text class="pt-6 text-body-1">Видалити цей захід? Відновити його буде неможливо.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="deleteDialog = false">Скасувати</v-btn>
          <v-btn color="error" depressed :loading="deleting" @click="deleteEvent">Так, видалити</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="categoriesDialog" max-width="480">
      <v-card>
        <v-card-title class="subtitle-1 font-weight-bold">Категорії заходів</v-card-title>
        <v-card-text>
          <div v-for="category in categories" :key="category.id" class="d-flex align-center py-1">
            <span>{{ category.name }}</span>
            <span class="grey--text ml-2">({{ category.events }})</span>
            <v-spacer></v-spacer>
            <v-btn icon small color="error" title="Видалити категорію" @click="deleteCategory(category)">
              <v-icon small>mdi-delete-outline</v-icon>
            </v-btn>
          </div>
          <div class="d-flex align-center mt-3">
            <v-text-field v-model="newCategory" label="Нова категорія" hide-details dense @keyup.enter="createCategory"></v-text-field>
            <v-btn small color="primary" depressed class="ml-2" :disabled="!newCategory.trim()" @click="createCategory">Додати</v-btn>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="categoriesDialog = false">Закрити</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Vue from "vue";
import ApiClient from "@/libs/http-client";
import { EDITOR_PALETTE } from "@/utils/editorPalette";

const DEFAULT_DETAILS = [
  { title: "Коли", type: "text" },
  { title: "Де", type: "text" },
  { title: "Скільки", type: "price" },
  { title: "Для кого", type: "text" },
];

let detailKey = 0;

function detailRow(item = {}) {
  detailKey += 1;
  return {
    key: detailKey,
    title: item.title || "",
    text: item.text || "",
    type: item.type === "price" ? "price" : "text",
  };
}

function emptyForm() {
  return {
    title: "",
    short_description: "",
    seo_title: "",
    seo_description: "",
    content: "",
    event_category_id: null,
    host_profile_id: null,
    host_title: "",
    format: "",
    starts_on: "",
    ends_on: "",
    details: DEFAULT_DETAILS.map(detailRow),
  };
}

function toast(text, icon = "success") {
  Vue.swal({
    target: document.getElementById("main"),
    text,
    icon,
    timer: 4000,
    toast: true,
    position: "top-right",
    showConfirmButton: false,
  });
}

export default {
  name: "events",
  metaInfo() {
    return { title: "Платформа / Заходи" };
  },
  data() {
    return {
      statusTabs: [
        { value: "", label: "Усі" },
        { value: "published", label: "Опубліковані" },
        { value: "waiting", label: "Заплановані" },
        { value: "draft", label: "Чернетки" },
        { value: "finished", label: "Завершені" },
      ],
      statusTab: 0,
      page: 1,
      events: [],
      meta: { last_page: 1 },
      listLoading: false,
      categories: [],
      authors: [],
      hostTitles: ["Ведуча", "Ведучий", "Ведучі", "Організатор", "Спікер"],
      form: emptyForm(),
      eventId: null,
      eventSlug: null,
      eventStatus: null,
      previewFile: null,
      previewUrl: null,
      publishNow: true,
      publishDate: null,
      publishTime: null,
      dateMenu: false,
      saving: false,
      deleting: false,
      deleteDialog: false,
      categoriesDialog: false,
      newCategory: "",
      siteUrl: (process.env.VUE_APP_MAIN_PAGE || "").replace(/\/$/, ""),
      editorToolbar: [
        [{ header: [2, 3, false] }],
        ["bold", "italic", "underline"],
        [{ color: EDITOR_PALETTE }, { background: EDITOR_PALETTE }],
        [{ list: "ordered" }, { list: "bullet" }],
        ["blockquote"],
        [{ align: [] }],
        ["link", "image", "video"],
        ["clean"],
      ],
    };
  },
  computed: {
    // "онлайн" plus the places already used in other events
    formatOptions() {
      const used = this.events.map((item) => item.format).filter(Boolean);
      return [...new Set(["онлайн", ...used])];
    },
  },
  watch: {
    statusTab() {
      this.page = 1;
      this.loadEvents();
    },
    page() {
      this.loadEvents();
    },
    publishNow(value) {
      if (value) {
        this.publishDate = null;
        this.publishTime = null;
      }
    },
  },
  beforeMount() {
    this.loadEvents();
    this.loadCategories();
    ApiClient.get("api/admin/blog/posts/authors").then((response) => {
      this.authors = response.data.data.map((author) => ({
        ...author,
        label: author.specialty ? `${author.full_name} — ${author.specialty}` : author.full_name,
      }));
    });
  },
  methods: {
    loadEvents() {
      this.listLoading = true;
      const status = this.statusTabs[this.statusTab || 0].value;
      return ApiClient.get(`api/admin/events?page=${this.page}${status ? "&status=" + status : ""}`)
        .then((response) => {
          this.events = response.data.data;
          this.meta = response.data.meta;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    loadCategories() {
      return ApiClient.get("api/admin/events/categories").then((response) => {
        this.categories = response.data.data;
      });
    },
    statusIcon(status) {
      return { WAITING: "mdi-calendar", PUBLISHED: "mdi-check-bold", DRAFT: "mdi-progress-wrench", FINISHED: "mdi-calendar-check" }[status];
    },
    resetForm() {
      this.form = emptyForm();
      this.eventId = null;
      this.eventSlug = null;
      this.eventStatus = null;
      this.previewFile = null;
      this.previewUrl = null;
      this.publishNow = true;
      this.publishDate = null;
      this.publishTime = null;
    },
    selectEvent(item) {
      this.form = {
        title: item.title || "",
        short_description: item.short_description || "",
        seo_title: item.seo_title || "",
        seo_description: item.seo_description || "",
        content: item.content || "",
        event_category_id: item.event_category_id,
        host_profile_id: item.host_profile_id,
        host_title: item.host_title || "",
        format: item.format || "",
        starts_on: item.starts_on || "",
        ends_on: item.ends_on || "",
        details: (item.details || []).map(detailRow),
      };
      this.eventId = item.id;
      this.eventSlug = item.slug;
      this.eventStatus = item.status;
      this.previewFile = null;
      this.previewUrl = item.preview_image;
      this.publishNow = item.status === "PUBLISHED";
      this.$nextTick(() => {
        if (item.status === "WAITING" && item.publish_at) {
          const [date, time] = item.publish_at.split(" ");
          this.publishDate = date;
          this.publishTime = time ? time.slice(0, 5) : null;
        }
      });
    },
    addDetail() {
      this.form.details.push(detailRow());
    },
    moveDetail(index, shift) {
      const details = this.form.details.slice();
      const [item] = details.splice(index, 1);
      details.splice(index + shift, 0, item);
      this.form.details = details;
    },
    onPreviewPicked(event) {
      const file = event.target.files[0];
      if (!file) return;
      this.previewFile = file;
      this.previewUrl = URL.createObjectURL(file);
      event.target.value = "";
    },
    removePreview() {
      this.previewFile = null;
      this.previewUrl = null;
    },
    handleImageAdded(file, Editor, cursorLocation, resetUploader) {
      const payload = new FormData();
      payload.append("image", file);
      ApiClient.post("api/admin/blog/posts/images", payload).then((result) => {
        Editor.insertEmbed(cursorLocation, "image", result.data.data.url);
        resetUploader();
      });
    },
    save() {
      if (!this.previewUrl) {
        toast("Додайте картинку заходу", "warning");
        return;
      }
      if (!this.publishNow && this.publishDate && !this.publishTime) {
        toast("Вкажіть час публікації", "warning");
        return;
      }

      const payload = new FormData();
      ["title", "short_description", "seo_title", "seo_description", "content", "event_category_id", "host_profile_id"].forEach((field) => {
        payload.append(field, this.form[field] == null ? "" : this.form[field]);
      });
      payload.append("host_title", (this.form.host_title || "").trim());
      payload.append("format", (this.form.format || "").trim());
      payload.append("starts_on", this.form.starts_on || "");
      payload.append("ends_on", this.form.ends_on || "");
      this.form.details.forEach((item, i) => {
        payload.append(`details[${i}][title]`, item.title);
        payload.append(`details[${i}][text]`, item.text);
        payload.append(`details[${i}][type]`, item.type);
      });
      payload.append("published", this.publishNow ? 1 : 0);
      if (!this.publishNow && this.publishDate && this.publishTime) {
        payload.append("publish_at", `${this.publishDate} ${this.publishTime}:00`);
      }
      if (this.previewFile) {
        payload.append("preview_image", this.previewFile);
      }

      this.saving = true;
      ApiClient.post(this.eventId ? `api/admin/events/${this.eventId}` : "api/admin/events", payload, {
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then((response) => {
          toast(response.data.message);
          this.selectEvent(response.data.data);
          this.loadEvents();
          this.loadCategories();
        })
        .finally(() => {
          this.saving = false;
        });
    },
    deleteEvent() {
      this.deleting = true;
      ApiClient.delete(`api/admin/events/${this.eventId}`)
        .then((response) => {
          toast(response.data.message);
          this.deleteDialog = false;
          this.resetForm();
          this.loadEvents();
          this.loadCategories();
        })
        .finally(() => {
          this.deleting = false;
        });
    },
    createCategory() {
      const name = this.newCategory.trim();
      if (!name) return;
      ApiClient.post("api/admin/events/categories", { name }).then((response) => {
        this.categories = response.data.data;
        this.newCategory = "";
      });
    },
    deleteCategory(category) {
      ApiClient.delete(`api/admin/events/categories/${category.id}`).then((response) => {
        this.categories = response.data.data;
        if (this.form.event_category_id === category.id) {
          this.form.event_category_id = null;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
// list dots and numbers in the brand colour, as on the event page
.blog-editor ::v-deep .ql-editor li::before {
  color: #00a3b7;
  font-weight: 700;
}
.events-admin__selected {
  outline: 2px solid $primary;
}
.events-admin__detail {
  padding: 12px 0 14px;
  border-bottom: 1px solid #e3e6e8;
}
.events-admin__detail-title {
  max-width: 260px;
}
.events-admin__upload {
  display: flex;
  width: 450px;
  max-width: 100%;
  height: 250px;
  padding: 10px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  &:hover {
    background-color: rgba(0, 0, 0, 0.1);
  }
}
.events-admin__upload-inner {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  border: 3px dashed $primary;
  font-size: 22px;
}
.events-admin__preview {
  position: relative;
  width: 450px;
  max-width: 100%;
  height: 250px;
  border: 1px solid $primary;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.events-admin__preview-remove {
  position: absolute !important;
  top: 10px;
  right: 10px;
  padding: 5px;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.2);
  color: #e0405c !important;
}
</style>
